export const ShowUxSignalsFeedbackPrompt_StartPage = 'ShowUxSignalsFeedbackPrompt_StartPage' as const;
export const ShowUxSignalsFeedbackPrompt_ProjectAccountingReceipt = 'ShowUxSignalsFeedbackPrompt_ProjectAccountingReceipt' as const;
export const ReleaseOfCollaterals = 'ReleaseOfCollaterals' as const;
export const FormLayoutRedesignEnabled = 'DigiBankMypage_FormLayoutRedesignEnabled' as const;
